import React from 'react';
import logger from '../utils/frontendLogger';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Log error to backend
        logger.error(
            error.message || 'React component error',
            'react_error_boundary',
            {
                componentStack: errorInfo.componentStack,
                stackTrace: error.stack,
                errorName: error.name,
                errorToString: error.toString()
            }
        );

        this.setState({
            error,
            errorInfo
        });
    }

    render() {
        if (this.state.hasError) {
            // Fallback UI
            return (
                <div style={{
                    padding: '20px',
                    margin: '20px',
                    border: '2px solid #ff6b6b',
                    borderRadius: '8px',
                    backgroundColor: '#fff5f5',
                    color: '#c92a2a'
                }}>
                    <h2>⚠️ Something went wrong</h2>
                    <p>We're sorry for the inconvenience. The error has been logged and we'll look into it.</p>
                    
                    {process.env.NODE_ENV === 'development' && this.state.error && (
                        <details style={{ marginTop: '20px', whiteSpace: 'pre-wrap' }}>
                            <summary style={{ cursor: 'pointer', fontWeight: 'bold' }}>
                                Error Details (Development Only)
                            </summary>
                            <div style={{
                                marginTop: '10px',
                                padding: '10px',
                                backgroundColor: '#f8f9fa',
                                borderRadius: '4px',
                                fontSize: '12px',
                                fontFamily: 'monospace'
                            }}>
                                <strong>{this.state.error.toString()}</strong>
                                <br />
                                {this.state.errorInfo.componentStack}
                            </div>
                        </details>
                    )}
                    
                    <button
                        onClick={() => window.location.reload()}
                        style={{
                            marginTop: '20px',
                            padding: '10px 20px',
                            backgroundColor: '#ff6b6b',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '14px'
                        }}
                    >
                        Reload Page
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
